/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputDivisionShort
 */
export interface OutputDivisionShort {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDivisionShort
     */
    blocked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputDivisionShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputDivisionShort
     */
    name: string;
}

/**
 * Check if a given object implements the OutputDivisionShort interface.
 */
export function instanceOfOutputDivisionShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputDivisionShortFromJSON(json: any): OutputDivisionShort {
    return OutputDivisionShortFromJSONTyped(json, false);
}

export function OutputDivisionShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputDivisionShort {
    if (json == null) {
        return json;
    }
    return {
        
        'blocked': json['blocked'] == null ? undefined : json['blocked'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputDivisionShortToJSON(value?: OutputDivisionShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blocked': value['blocked'],
        'id': value['id'],
        'name': value['name'],
    };
}

